module.exports = __webpack_public_path__ + "static/img/store-ranking-rule-pic-2.51c95cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/store-ranking-rule-pic-2.png
// module id = VW8H
// module chunks = 3